import { useCallback, useMemo, useState } from 'react'

import { playPopupOpenSound } from '../game/audio/uiSounds'
import { GetLandingPageMappingsDocument } from '../lib/graphql/generated/graphql'
import { store } from '../stores/store'
import {
    landingMappingRowsFromQuery,
    resolveParentsAppointmentOutcome,
} from '../utils/parentsLandingBooking'
import { useRefIdQuery } from './useRefIdQuery'

/**
 * Same branching as `ParentsLandingScreen` appointment CTA: optional external handler,
 * branch picker, or single booking URL.
 */
export function useParentsAppointmentActions() {
    const [showBranchPicker, setShowBranchPicker] = useState(false)
    const refIdQuery = useRefIdQuery()
    const mappingsData = store.getCachedQuery(GetLandingPageMappingsDocument)
    const mappingRows = useMemo(
        () => landingMappingRowsFromQuery(mappingsData),
        [mappingsData],
    )
    const referrerMatchMapping = store.entryReferrerLandingMatch?.mapping ?? null
    const appointmentOutcome = useMemo(
        () =>
            resolveParentsAppointmentOutcome({
                refIdQuery,
                mappingRows,
                referrerMatchMapping,
            }),
        [refIdQuery, mappingRows, referrerMatchMapping],
    )

    const openAppointment = useCallback(
        (onLearnMore?: () => void) => {
            if (onLearnMore) {
                onLearnMore()
                return
            }
            if (appointmentOutcome.kind === 'branchPicker') {
                playPopupOpenSound()
                setShowBranchPicker(true)
                return
            }
            window.open(appointmentOutcome.url, '_blank', 'noopener,noreferrer')
        },
        [appointmentOutcome],
    )

    return {
        mappingRows,
        showBranchPicker,
        setShowBranchPicker,
        openAppointment,
    }
}
